import { css } from '@/styled-system/css';

export const deletedAttachmentsContainerStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  padding: 'default',
  marginBottom: 'tighter',
  border: '1px solid',
  borderColor: 'border.muted',
  borderRadius: '500',
});
